import BaseResourceService from "../BaseResourceService.js";

const stringifyParams = (obj = {}) =>
  Object.entries(obj)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => encodeURIComponent(k) + "=" + encodeURIComponent(v))
    .join("&");

/**
 * Cliente do endpoint /admin/log-erro (Tarefa-19336 — "Visualizar Log").
 *
 * Restrito a usuários administradores na empresa logada. O back filtra
 * por empresa automaticamente (cada admin só vê o que é da empresa dele).
 */
class LogErroService extends BaseResourceService {

  endpoint = "admin/log-erro";

  listar = async (filtros = {}, page = 0, size = 50) => {
    const params = { ...filtros, page, size };
    const response = await this.get(this.endpoint, { params });
    return response?.data;
  };

  listarAgrupado = async (filtros = {}, page = 0, size = 50) => {
    const params = { ...filtros, page, size };
    const response = await this.get(this.endpoint + "/agrupado", { params });
    return response?.data;
  };

  detalhar = async (id) => {
    const response = await this.get(this.endpoint + "/" + id);
    return response?.data;
  };

  contexto = async (id) => {
    const response = await this.get(this.endpoint + "/" + id + "/contexto");
    return response?.data || [];
  };

  lerAoVivo = async (aposSeq = 0) => {
    const response = await this.get(this.endpoint + "/ao-vivo", { params: { aposSeq } });
    return response?.data || [];
  };

  registrarAoVivoFrontend = async (payloadOrMensagem, origem = "frontend", stacktrace = null) => {
    const payload = typeof payloadOrMensagem === "string"
      ? { mensagem: payloadOrMensagem, origem, stacktrace }
      : payloadOrMensagem;
    return this.post(this.endpoint + "/ao-vivo/frontend", payload);
  };

  encerrarAoVivo = async () => {
    try {
      return await this.post(this.endpoint + "/ao-vivo/encerrar", {});
    } catch (e) {
      return null;
    }
  };

  /**
   * Apaga todos os registros da empresa logada da tabela log_erro.
   * Cada admin so apaga o log da propria empresa.
   */
  limparErrosRegistrados = async () => {
    const response = await this.delete(this.endpoint);
    return response?.data;
  };

  exportarCsvUrl = (filtros = {}) => {
    const query = stringifyParams(filtros);
    return this.endpoint + "/export" + (query ? "?" + query : "");
  };

  /**
   * Baixa o CSV dos erros do filtro atual usando o mesmo axios autenticado
   * (baseURL + token + empresa-id) das demais chamadas. Retorna o Blob.
   */
  baixarCsv = async (filtros = {}) => {
    const response = await this.getBlob(this.exportarCsvUrl(filtros));
    return response?.data;
  };

  /** Usado pelo ErrorBoundary/window.onerror para reportar erro do navegador. */
  reportarErroFrontend = async (payload) => {
    try {
      return await this.post(this.endpoint + "/frontend", payload);
    } catch (e) {
      // Nunca derruba a UI — se nem o report do erro funcionar, paciencia.
      // eslint-disable-next-line no-console
      console.warn("Falha ao reportar erro pro backend:", e?.message);
      return null;
    }
  };
}

const service = new LogErroService();
export default service;
